import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetDataParam} from "../../../../../../../../../core/shared/widget/widget-data-param";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'cm-contract-service',
    templateUrl: './cm-contract-service.component.html',
    standalone: false
})
export class CmContractServiceComponent implements OnInit, OnChanges, OnDestroy {
    @Input() objectIdentifier: ObjectIdentifier;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    contractLabelWidget: WidgetData;
    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.createContractServiceWidget();
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    createContractServiceWidget(){
        this.contractLabelWidget = WidgetFactory.createWidgetListEntityBasicQl('cm.contract.customer.specific.page.contract.label', 'Leistungen', 'cm.ContractLabel', [FilterCriteria.create("e.contractId", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], [], false, new WidgetDataParam("size", "S"));

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'contractDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.contractLabelWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }
}
